import './Styles.scss'

// Tabs switcher

(() => {
    const buttonsState = document.querySelectorAll(".widget__button-switcher");

    buttonsState.forEach(btn => {
        btn.addEventListener("click", (b) => {
            const parentElement = b.target.parentElement.parentElement.parentElement;
            const stateOne = parentElement.querySelector(".state-1").classList;
            const stateTwo = parentElement.querySelector(".state-2").classList;
            const buttonID = b.target.classList;
            const active = "active";
            const animations = ["hiding-animation", "showing-animation"];

            const firstState = b.target.previousElementSibling !== null && b.target.previousElementSibling;
            const secondState = b.target.nextElementSibling !== null && b.target.nextElementSibling;

            if(buttonID.contains("for-state-1")){
                if(secondState.classList.contains(active)){
                    secondState.classList.remove(active);
                    buttonID.add(active);
                }
                stateTwo.add(animations[0]);
                setTimeout(() => {
                    stateOne.add(animations[1]);
                    stateTwo.remove(animations[0]);
                }, 200);
                
                setTimeout(() => {
                    return stateOne.add(active), stateTwo.contains(active) && stateTwo.remove(active);
                }, 190);
                setTimeout(() => { 
                    stateOne.remove(animations[1]);
                }, 210);
            } else if(buttonID.contains("for-state-2")){
                if(firstState.classList.contains(active)){
                    firstState.classList.remove(active);
                    buttonID.add(active);
                }
                stateOne.add(animations[0]);
                setTimeout(() => {
                    stateTwo.add(animations[1]);
                    stateOne.remove(animations[0]);
                }, 200);
                setTimeout(() => {
                    return stateTwo.add(active), stateOne.contains(active) && stateOne.remove(active);
                }, 190);
                setTimeout(() => { 
                    stateTwo.remove(animations[1]);
                }, 210);
            }
            else {
                return
            }
        })
    })
})();
